/*
  ラッピング Add‑on をカートに入れる際、
  その行（addonLine）へ「どの親商品か」を埋め込むスクリプト
*/
document.addEventListener('DOMContentLoaded', () => {
  // ---- 1) 既存の AddToCart をフック ---------------------------
  const form = document.querySelector('product-form form[action*="/cart/add"]');
  if (!form) return;

  form.addEventListener('submit', async (evt) => {
    // Shopify 標準 submit → メイン商品が先に追加される
    await new Promise(r => setTimeout(r, 500));          // 少し待つ
    const cart = await (await fetch('/cart.js')).json(); // 最新カート取得

    // ---- 2) 親商品・ラッピング行を抽出 -----------------------
    const mainItem   = cart.items.find(i => !i.properties?.Wrapped_for_title);
    const wrapping   = cart.items.find(i => i.properties?.is_globo_addon);
    if (!mainItem || !wrapping) return; // 片方なければ何もしない

    // ---- 3) ラッピング行に親情報を書き込む -------------------
    const props = Object.assign({}, wrapping.properties, {
      Wrapped_for_title  : mainItem.title,
      Wrapped_for_sku    : mainItem.sku,
      Wrapped_for_variant: mainItem.variant_id
    });

    await fetch('/cart/change.js', {                      // プロパティ上書き
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ id: wrapping.key, properties: props })
    });
  });
});
